<template>
  <el-container class="fill-height">
      <!-- <h1>111</h1> -->
        <el-header style="height:70px;">
            <app-header></app-header>
        </el-header>
        <el-container class="section">
            <router-view></router-view>
        </el-container>
  </el-container>
</template>
<script>
import AppHeader from './app-header1'

export default {
    name: 'layout',
    components: {
        AppHeader,
    },
    data () {
        return {
            showAside:true,
        }
    },
    mounted(){
      
    }
}
</script>
<style>
  .section{
		height: calc(100% - 70px);
    display: flex;
    display: -webkit-flex;
    background: #F8F8F8;
  }
</style>


// WEBPACK FOOTER //
// src/pages/views/layout/layout1.vue